// extracted by mini-css-extract-plugin
module.exports = {"cell":"StatusCell_cell__3uV5y","wrapper":"StatusCell_wrapper__7oWOF"};